<template>
  <div id="contenedor-contratos-default">
    <v-container fluid>
      <v-card class="mb-4" flat>
        <v-card-text>
          <titulo-tool-bar titulo="Contratos">
            <template v-slot:opciones-derecha>
              <template v-if="$vuetify.breakpoint.xs">
                <v-menu
                  v-model="mostrarOpciones"
                  :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    @click="mostrarExportarConceptosFavoritos =
                      !mostrarExportarConceptosFavoritos">
                      <v-list-item-icon class="mx-0 px-2">
                        <v-icon> mdi-star </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title> Exportar Conceptos Favoritos </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    @click="mostrarVentanaExcelContratos = !mostrarVentanaExcelContratos">
                      <v-list-item-icon class="mx-0 px-2">
                        <v-icon> mdi-file-excel </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title> Exportar Contratos </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    @click="abrirCalendarioActividades">
                      <v-list-item-icon class="mx-0 px-2">
                        <v-icon> mdi-calendar-month </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title> Ver Calendario de Actividades </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    :to="{ name: 'contratosEstadisticas' }">
                      <v-list-item-icon class="mx-0 px-2">
                        <v-icon> mdi-poll </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title> Estadisticas </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    :to="{ name: 'contratosConfiguracionFirmas' }">
                      <v-list-item-icon class="mx-0 px-2">
                        <v-icon> mdi-cog-outline </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title> Configuración </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-else>
                <v-tooltip
                v-if="mixValidaScopesActions(1)"
                top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="mostrarExportarConceptosFavoritos =
                      !mostrarExportarConceptosFavoritos">
                      <v-icon> mdi-star </v-icon>
                    </v-btn>
                  </template>
                  <span> Exportar Conceptos Favoritos </span>
                </v-tooltip>
                <v-tooltip
                v-if="mixValidaScopesActions(1)"
                top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="mostrarVentanaExcelContratos = !mostrarVentanaExcelContratos">
                      <v-icon> mdi-file-excel </v-icon>
                    </v-btn>
                  </template>
                  <span> Exportar Contratos </span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="abrirCalendarioActividades">
                      <v-icon> mdi-calendar-month </v-icon>
                    </v-btn>
                  </template>
                  <span> Ver Calendario de Actividades </span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      :to="{ name: 'contratosEstadisticas' }">
                      <v-icon> mdi-poll </v-icon>
                    </v-btn>
                  </template>
                  <span> Estadisticas </span>
                </v-tooltip>
                <v-tooltip
                v-if="mixValidaScopesActions(1)"
                top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :to="{ name: 'contratosConfiguracionFirmas' }"
                      icon
                      v-bind="attrs"
                      v-on="on">
                      <v-icon> mdi-cog-outline </v-icon>
                    </v-btn>
                  </template>
                  <span> Configuración </span>
                </v-tooltip>
              </template>
            </template>
          </titulo-tool-bar>
          <tool-bar
            :filtros="filtros"
            :listaContratos="getContratos"
            v-on:nuevoContrato="registrarNuevoContrato"
            v-on:abrirCalendarioActividades="abrirCalendarioActividades">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :listadoContratos="getListadoDeContratos">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoContrato"
      persistent
      scrollable
      width="80%">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo contrato
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="$refs.registrarNuevoContrato.cerrar()">
            <v-icon
              class="secondary--text"
              large>
              highlight_off
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <registrar-nuevo-contrato
            v-if="mostrarVentanaRegistrarNuevoContrato"
            ref="registrarNuevoContrato"
            :obrasContratos="getIdsObrasContratos"
            @formularioValido="setFormularioValido"
            @enviandoFormulario="setEnviandoFormulario"
            v-on:cerrar="cerrarRegistrarNuevoContrato">
          </registrar-nuevo-contrato>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="$refs.registrarNuevoContrato.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar"
            @click="$refs.registrarNuevoContrato.mixAgregarContrato()">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="esteContrato"
      v-model="mostrarVentanaEditarContrato"
      persistent
      scrollable
      width="80%">
      <v-card>
        <v-card-title class="secondary--text">
          Editar contrato
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="$refs.editarContrato.cerrar()">
            <v-icon
              class="secondary--text"
              large>
              highlight_off
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <editar-contrato
            v-if="mostrarVentanaEditarContrato"
            ref="editarContrato"
            :contratoEditar="esteContrato"
            @formularioValido="setFormularioValido"
            @enviandoFormulario="setEnviandoFormulario"
            v-on:cerrar="cerrarEditarContrato">
          </editar-contrato>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="$refs.editarContrato.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar"
            @click="$refs.editarContrato.mixActualizarContrato()">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Ventana Calendario de Actividades de Contratos -->
    <v-dialog
      scrollable
      v-model="mostrarVentanaCalendarioActividades"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <v-card>
        <v-card-title class="secondary--text">
          Calendario de Actividades de Contratos
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarCalendarioActividades">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <calendario-actividades
          :listadoContratos="getContratos"
          :actividadesTodas="getActividadesTodas">
          </calendario-actividades>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarCalendarioActividades"
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="mostrarVentanaExcelContratos"
      v-model="mostrarVentanaExcelContratos"
      width="400">
      <excel-contratos
      :filtros="filtros"
      v-on:cerrar="mostrarVentanaExcelContratos = !mostrarVentanaExcelContratos">
      </excel-contratos>
    </v-dialog>
    <v-dialog
      v-if="mostrarExportarConceptosFavoritos"
      v-model="mostrarExportarConceptosFavoritos"
      width="400">
      <excel-conceptos-favoritos
      v-on:cerrar="mostrarExportarConceptosFavoritos = !mostrarExportarConceptosFavoritos">
      </excel-conceptos-favoritos>
    </v-dialog>
    <v-dialog
      v-if="mostrarVentanaEliminarContrato"
      v-model="mostrarVentanaEliminarContrato"
      width="600">
      <eliminar-contrato
      :contratoEliminar="esteContrato"
      v-on:cerrar="cerrarEliminarContrato">
      </eliminar-contrato>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosListado.gql';
import ACTIVIDADES_TODAS from '@/graphql/querys/administracion/actividades/actividadesTodas.gql';
import CalendarioActividades from '@/components/administracion/contratos/calendarioactividades/CalendarioActividades.vue';
import ExcelContratos from '@/components/exportar/exceles/ExcelContratos.vue';
import ExcelConceptosFavoritos from '@/components/exportar/exceles/ExcelConceptosFavoritos.vue';
import CustomButton from '@/components/buttons/Button.vue';
import RegistrarNuevoContrato from '@/components/administracion/contratos/Nuevo.vue';
import EditarContrato from '@/components/administracion/contratos/Editar.vue';
import EliminarContrato from '@/components/administracion/contratos/Eliminar.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'ContratosDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoContrato,
    EditarContrato,
    EliminarContrato,
    CustomButton,
    CalendarioActividades,
    ExcelContratos,
    ExcelConceptosFavoritos,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarOpciones: false,
      mostrarVentanaRegistrarNuevoContrato: false,
      mostrarVentanaEditarContrato: false,
      mostrarVentanaEliminarContrato: false,
      mostrarVentanaCalendarioActividades: false,
      mostrarVentanaExcelContratos: false,
      mostrarExportarConceptosFavoritos: false,
      formularioValido: false,
      enviandoFormulario: false,
      esteContrato: null,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        financiamiento: 'Todos',
        programas: [],
        contratistas: [],
        supervisores: [],
        guardarFiltros: false,
      },
    };
  },
  apollo: {
    contratosByEjercicio: {
      query: CONTRATOS,
      variables() {
        let ejercicio = new Date().getFullYear();
        let periodo = 1;

        if (typeof this.filtros.ejercicio === 'string') {
          const split = this.filtros.ejercicio.split('-');
          ejercicio = Number(split[0]);
          periodo = Number(split[1]);
        } else {
          ejercicio = Number(this.filtros.ejercicio);
        }
        return ({
          ejercicio,
          periodo,
        });
      },
    },
    actividadesTodas: {
      query: ACTIVIDADES_TODAS,
    },
  },
  computed: {
    getIdsObrasContratos() {
      if (!this.contratosByEjercicio) return [];
      const idsObrasContratos = [];
      this.contratosByEjercicio.forEach((contrato) => {
        contrato.obras.forEach((obra) => {
          idsObrasContratos.push(obra.idObra);
        });
      });
      return idsObrasContratos;
    },
    getContratos() {
      if (!this.contratosByEjercicio) return [];
      return this.contratosByEjercicio// Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        });
    },
    getListadoDeContratos() {
      if (!this.contratosByEjercicio) return [];
      return this.contratosByEjercicio
        // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        });
    },

    getActividadesTodas() {
      if (!this.actividadesTodas) return [];
      return this.actividadesTodas;
    },
  },
  mounted() {
    // Checar si hay filtros guardados.
    const filtrosGuardados = JSON.parse(this.mixGetFiltro('filtros-contratos'));
    if (filtrosGuardados) {
      this.filtros = JSON.parse(this.mixGetFiltro('filtros-contratos'));
    }

    eventBus.$on('editar-contrato', (contrato) => {
      this.esteContrato = contrato;
      this.mostrarVentanaEditarContrato = true;
    });
    eventBus.$on('eliminar-contrato', (contrato) => {
      this.esteContrato = contrato;
      this.mostrarVentanaEliminarContrato = true;
    });
  },
  methods: {
    setFiltros(filtros) {
      this.filtros = filtros;
    },
    setFormularioValido(valor) {
      this.formularioValido = valor;
    },
    setEnviandoFormulario(valor) {
      this.enviandoFormulario = valor;
    },
    registrarNuevoContrato() {
      this.mostrarVentanaRegistrarNuevoContrato = true;
      this.enviandoFormulario = false;
    },
    cerrarRegistrarNuevoContrato() {
      this.mostrarVentanaRegistrarNuevoContrato = false;
    },
    cerrarEditarContrato() {
      this.mostrarVentanaEditarContrato = false;
      this.enviandoFormulario = false;
      this.formularioValido = false;
      this.esteContrato = null;
    },
    cerrarEliminarContrato() {
      this.mostrarVentanaEliminarContrato = false;
      this.esteContrato = null;
    },
    abrirCalendarioActividades() {
      this.mostrarVentanaCalendarioActividades = true;
    },
    cerrarCalendarioActividades() {
      this.mostrarVentanaCalendarioActividades = false;
    },
  },
  watch: {
    filtros: {
      handler(filtros) {
        if (filtros.guardarFiltros) {
          this.mixGuardarFiltros('filtros-contratos', JSON.stringify(filtros));
        } else {
          this.mixRemoverFiltro('filtros-contratos');
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
</style>
